import { render, staticRenderFns } from "./RefundDetail.vue?vue&type=template&id=31e23217&scoped=true&"
import script from "./RefundDetail.vue?vue&type=script&lang=js&"
export * from "./RefundDetail.vue?vue&type=script&lang=js&"
import style0 from "./RefundDetail.vue?vue&type=style&index=0&id=31e23217&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e23217",
  null
  
)

export default component.exports